import moment from "moment";

export const getTimeFormatter = format => {
  return time => {
    if (time) {
      let dateString = combineDateAndTime(time);
      if (format == "am/pm") {
        return moment(dateString).format("h:mm A");
      } else {
        return moment(dateString).format("HH:mm");
      }
    } else {
      return moment().format("HH:mm");
    }
  };
};

export const combineDateAndTime = function(time) {
  let timeString = time;
  var dateString = moment().format("YYYY-MM-DD");
  var combined = new Date(dateString + " " + timeString);
  combined = moment(dateString + " " + timeString);
  return combined;
};



// WEBPACK FOOTER //
// ./src/helper/timeFormat.js